/**
 * @file 国家配置
 * @author huangweisheng (huangweisheng@bytedance.com)
 *
 */

namespace Country {
  export enum Code {
    Australia = "AU",
    Erpyt = "EG",
    France = "FR",
    Germany = "DE",
    Indonesia = "ID",
    Israel = "IL",
    Italy = "IT",
    Japan = "JP",
    South_Korea = "KR",
    Malaysia = "MY",
    Russia = "RU",
    Saudi_Arabia = "SA",
    Singapore = "SG",
    Spain = "ES",
    Thailand = "TH",
    Turkey = "TR",
    United_Arab_Emirates = "AE",
    United_Kingdom = "GB",
    United_States = "US",
    Vietnam = "VN",
    Ireland = "IE",
    Belgium = "BE",
    India = "IN",
    Philippines = "PH",

    Canada = "CA",
    China = "CN",
    Mexico = "MX"
  }

  export enum Name {
    Australia = "Australia",
    Erpyt = "Egpyt",
    France = "France",
    Germany = "Germany",
    Indonesia = "Indonesia",
    Israel = "Israel",
    Italy = "Italy",
    Japan = "Japan",
    South_Korea = "South Korea",
    Malaysia = "Malaysia",
    Russia = "Russia",
    Saudi_Arabia = "Saudi Arabia",
    Singapore = "Singapore",
    Spain = "Spain",
    Thailand = "Thailand",
    Turkey = "Turkey",
    United_Arab_Emirates = "United Arab Emirates",
    United_Kingdom = "United Kingdom",
    United_States = "United States",
    Vietnam = "Vietnam",
    Ireland = "Ireland",
    Belgium = "Belgium",
    India = "India",
    Philippines = "Philippines",

    Canada = "Canada",
    China = "China",
    Mexico = "Mexico"
  }
}

export default Country;
